// import React, { Component } from "react";
// import Logo from '../assets/leafnet-logo.jpg';
// import '../root.css'
// import valid from '../utill/validation';
// import joi from 'joi';
// import Loading from './../utill/LoadingComponent';
// import config from '../config.json';
// import swal from "sweetalert";


// className Login extends Component {
//   state = {
//     user: {},
//     errors: '',


//   };
//   componentDidMount() {

//     // consol(this.props.errors)
//     this.setState({ errors: this.props.errors || {} });
//   }

//   schema = {
//     email: joi.string().email().required(),
//     password: joi.string().required(),
//     company: joi.string().required()
//   }

//   handleOnChange = (e) => {
//     const { user, errors } = { ...this.state };
//     const errorMessage = valid.validateProperty(e.currentTarget, this.schema);
//     if (errorMessage) errors[e.currentTarget.name] = errorMessage;
//     else delete errors[e.currentTarget.name];

//     user[e.currentTarget.name] = e.currentTarget.value;
//     this.setState({ user, errors: errors || {} });
//     // consol(this.state.user);
//   }
//   handleCheck = (data) => {
//     if (!config.Shared) {
//       if (config.Company == undefined) { swal('Wrong Configuration'); return }
//       data.company = config.Company;
//     }
//     const errors = valid.validate(data, this.schema);
//     this.setState({ errors: errors || {} });
//     if (errors) return;



//     this.props.handleLogin(this.state.user);

//   }
//   render() {
//     return (<div>

//       <div className="wrapper1 fadeInDown1">


//         <div id="formContent1">
//           <div className="fadeIn1 first1">
//             <img
//               src={Logo}
//               id="icon1"
//               alt="User Icon"
//             />
//           </div>


//           <input
//             required
//             type="text"
//             id="login1"
//             className="fadeIn1 second1"
//             name="email"
//             placeholder="Enter Email"
//             onChange={this.handleOnChange}
//           />
//           {this.state.errors.email && <div className="alert small alert-danger">{this.state.errors['email']}</div>}
//           <input
//             required
//             type="password"
//             id="password1"
//             className="fadeIn1 third1"
//             name="password"
//             placeholder="password"
//             onChange={this.handleOnChange}
//           />
//           {this.state.errors.password && <div className="alert small alert-danger">{this.state.errors['password']}</div>}
//           {config.Shared ? <input
//             required
//             type="text"
//             id="companyName"
//             className="fadeIn1 fourth1"
//             name="company"
//             placeholder="Company Name"
//             onChange={this.handleOnChange}
//           /> : <div className="medium ">{config.Company ? config.Company.toUpperCase() : ''}</div>}
//           {this.state.errors.company && <div className="alert small alert-danger">{this.state.errors['company']}</div>}
//           <input type="submit" className="fadeIn1 fourth1" value="Log In" onClick={() => { this.handleCheck(this.state.user) }} />


//           <div id="formFooter1">
//             <span className="underlineHover1" style={{ cursor: 'pointer' }} onClick={() => this.props.history.push('/forgot')}>
//               Forgot Password?
//             </span>
//             {/* <p className='small'>Powered By <a title="Driti Tech." target="_blank" rel="noopener noreferrer" href="https://drititech.com/">: Driti Technologies LLP.</a></p> */}


//           </div>
//         </div>
//         <div className="mt-4">
            
//             <p style={{fontSize:'20px'}} className='small '>Powered By <a className="links" style={{textDecoration:'none',color:'black',fontSize:'20px'}} title="Driti Tech." target="_blank" rel="noopener noreferrer" href="https://drititech.com/">: Driti Technologies LLP</a></p>


//           </div>
//       </div>
      
      
//       </div>
//     );
//   }
// }

// export default Login;



import React, { useState, useEffect, useRef } from "react";
import Logo from '../assets/leafnet-logo.jpg';
import '../root.css';
import valid from '../utill/validation';
import joi from 'joi';
import Loading from './../utill/LoadingComponent';

import config from '../config.json';
import swal from "sweetalert";
import AuthShell, { AuthField } from '../theme/AuthShell';
import useUiMode from '../theme/useUiMode';
import { UI_NEW } from '../theme/uiMode';
import TryNewUiButton from '../theme/TryNewUiButton';


const Login = (props) => {
  const [user, setUser] = useState(() => {
    // Initialize from sessionStorage to persist across remounts
    const savedUser = sessionStorage.getItem('loginFormData');
    return savedUser ? JSON.parse(savedUser) : {};
  });
  const [errors, setErrors] = useState(props.errors || {});
  const [showPassword, setShowPassword] = useState(false);
  const uiMode = useUiMode();

  const schema = {
    email: joi.string().email().required(),
    password: joi.string().required(),
    company: joi.string().required(),
  };

  useEffect(() => {
    // consol(props.errors);
  }, [props.errors]);

  // Save user data to sessionStorage whenever it changes
  useEffect(() => {
    if (user.email || user.password || user.company) {
      sessionStorage.setItem('loginFormData', JSON.stringify(user));
    }
  }, [user]);

  // Clear sessionStorage on successful login (component will unmount anyway)
  useEffect(() => {
    return () => {
      // Only clear if we're actually logging in (not just unmounting for other reasons)
    };
  }, []);

  const handleOnChange = (e) => {
    const errorMessage = valid.validateProperty(e.currentTarget, schema);
    setUser({
      ...user,
      [e.currentTarget.name]: e.currentTarget.value,
    });

    setErrors({
      ...errors,
      [e.currentTarget.name]: errorMessage,
    });
  };

  const handleCheck = (data, e) => {
    if (e) e.preventDefault();
    if (!config.Shared) {
      if (!config.Company) {
        swal('Wrong Configuration');
        return;
      }
      data.company = config.Company;
    }

    const validationErrors = valid.validate(data, schema);
    setErrors(validationErrors || {});

    if (!validationErrors) {
      props.handleLogin(user);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleCheck(user, e);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // New UI: same state, validation and submit as the classic form below, new markup.
  if (uiMode === UI_NEW) {
    const describedBy = (name) => (errors[name] ? `lnauth-${name}-error` : undefined);
    return (
      <AuthShell>
        <form className="lnauth-form" onSubmit={handleSubmit}>
          <div className="lnauth-head">
            <h1 className="lnauth-title">Welcome back</h1>
            <p className="lnauth-sub">Sign in to your plant.</p>
          </div>

          {config.Shared ? (
            <AuthField id="lnauth-company" label="Company" error={errors.company}>
              <input
                required
                type="text"
                id="lnauth-company"
                name="company"
                placeholder="Company name"
                autoComplete="organization"
                aria-invalid={Boolean(errors.company)}
                aria-describedby={describedBy('company')}
                onChange={handleOnChange}
                value={user.company || ''}
              />
            </AuthField>
          ) : (
            <div className="lnauth-field">
              <span className="lnauth-static-label">Company</span>
              <div className="lnauth-company">{config.Company ? config.Company.toUpperCase() : ''}</div>
            </div>
          )}

          <AuthField id="lnauth-email" label="Email" error={errors.email}>
            <input
              required
              type="text"
              inputMode="email"
              id="lnauth-email"
              name="email"
              placeholder="you@company.com"
              autoComplete="username"
              aria-invalid={Boolean(errors.email)}
              aria-describedby={describedBy('email')}
              onChange={handleOnChange}
              value={user.email || ''}
            />
          </AuthField>

          <AuthField
            id="lnauth-password"
            label="Password"
            error={errors.password}
            aside={
              <button type="button" className="lnauth-link" onClick={() => props.history.push('/forgot')}>
                Forgot password?
              </button>
            }
          >
            <div className="lnauth-input-wrap">
              <input
                required
                type={showPassword ? 'text' : 'password'}
                id="lnauth-password"
                name="password"
                placeholder="Enter password"
                autoComplete="current-password"
                aria-invalid={Boolean(errors.password)}
                aria-describedby={describedBy('password')}
                onChange={handleOnChange}
                value={user.password || ''}
              />
              <button
                type="button"
                className="lnauth-reveal"
                onClick={togglePasswordVisibility}
                aria-pressed={showPassword}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </AuthField>

          <button type="submit" className="lnauth-submit">
            Sign in
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </form>
      </AuthShell>
    );
  }

  return (
    <div>
      <div className="wrapper1 fadeInDown1 ">
        <form id="formContent1" onSubmit={handleSubmit}>

          <div className="fadeIn1 first1">
            <img src={Logo} id="icon1" alt="User Icon" style={{display:'inline'}}/>
          </div>
      <div className="text-center mt-3 mb-4 " style={{fontSize:'1.3rem'}}>Production Monitoring System</div>

          <input
            required
            type="text"
            id="login1"
            className="fadeIn1 second1"
            name="email"
            placeholder="Enter Email"
            onChange={handleOnChange}
            value={user.email || ''}
          />
          {errors.email && <div className="alert small alert-danger">{errors.email}</div>}

          {/* Other input fields and error displays */}
          
          <div style={{ position: 'relative', display: 'inline-block', width: '77%' }}>
            <input
              required
              type={showPassword ? "text" : "password"}
              id="password1"
              className="fadeIn1 third1"
              name="password"
              placeholder="Enter Password"
              onChange={handleOnChange}
              value={user.password || ''}
              style={{ width: '100%', paddingRight: '40px' }}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '5px',
                fontSize: '14px',
                color: '#666'
              }}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>
          {errors.password && <div className="alert small alert-danger">{errors.password}</div>}
          {config.Shared ? (
            <input
              required
              type="text"
              id="companyName"
              className="fadeIn1 fourth1"
              name="company"
              placeholder="Company Name"
              onChange={handleOnChange}
              value={user.company || ''}
            />
          ) : (
            <div className="medium ">{config.Company ? config.Company.toUpperCase() : ''}</div>
          )}
          {errors.company && <div className="alert small alert-danger">{errors.company}</div>}
          <input type="submit" className="fadeIn1 fourth1" value="Log In" />

          <div id="formFooter1">
            <span className="underlineHover1" style={{ cursor: 'pointer' }} onClick={() => props.history.push('/forgot')}>
              Forgot Password?
            </span>

          </div>
        </form>

        <TryNewUiButton />

        <div className="mt-4">
          <p style={{ fontSize: '20px' }} className='small '>Powered By <a className="links" style={{ textDecoration: 'none', color: 'black', fontSize: '20px' }} title="DRITI TECHNOLOGIES LLP" target="_blank" rel="noopener noreferrer" href="https://drititech.com">DRITI TECHNOLOGIES LLP</a></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
